import { CommonModule, registerLocaleData } from '@angular/common';
import { LOCALE_ID, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { WebPayComponent } from './components/webpay/webpay.component';
import { CommonService } from './services/common.service';
import { WebPayService } from './services/web-pay.service';

import { ButtonComponent } from './components/button/button.component';
import { CardDatosContratanteProductoComponent } from './components/card-datos-contratante/card-datos-contratante-producto.component';
import { CustomModalComponent } from './components/custom-modal/custom-modal.component';
import { FormLablelComponent } from './components/form-lablel/form-lablel.component';
import { FormTextComponent } from './components/form-text/form-text.component';
import { FormTitleLabelComponent } from './components/form-title-label/form-title-label.component';
import { InputTextComponent } from './components/input-text/input-text.component';
import { LoadingComponent } from './components/loading/loading.component';
import { PrintButtonComponent } from './components/print-button/print-button.component';
import { TableComponent } from './components/table/table.component';

import { LoaderService } from './services/loaderService';
import { PersonService } from './services/person.service';
import { ProductService } from './services/product.service';
import { UbicationService } from './services/ubication.service';

import { AuthGuard } from './guards/auth.guard';

import localeCL from '@angular/common/locales/es-CL';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxMaskModule } from 'ngx-mask';
import { CardAseguradoComponent } from '../modules/seguro-colectivo/components/card-asegurado/card-asegurado.component';
import { AportesInputComponent } from '../modules/seguro-individual/components/aportes-input/aportes-input.component';
import { AportesInputCUIComponent } from '../modules/seguro-individual/components/aportes-input-cui/aportes-input-cui.component';
import { PagarProductosComponent } from './components/pagar-productos/pagar-productos.component';
import { CardPagarProductoComponent } from './components/pagar-productos/components/card-pagar-producto/card-pagar-producto.component';
import { CardComponentComponent } from './components/card-component/card-component.component';
import { ColapsableComponent } from './components/colapsable/colapsable.component';
import { DynamicBannerComponent } from './components/dynamic-banner/dynamic-banner.component';
import { ErrorBannerComponent } from './components/error-banner/error-banner.component';
import { ErrorComponent } from './components/error/error.component';
import { FormDateDesdeHastaComponent } from './components/form-date-desde-hasta/form-date-desde-hasta.component';
import { FormInputDateComponent } from './components/form-input-date/form-input-date.component';
import { FormInputTextComponent } from './components/form-input-text/form-input-text.component';
import { FormSelectHeaderComponent } from './components/form-select-header/form-select-header.component';
import { FormSelectComponent } from './components/form-select/form-select.component';
import { JsonViewComponent } from './components/json-view/json-view.component';
import { MiniLoaderComponent } from './components/mini-loader/mini-loader.component';
import { PaginatorCustomComponent } from './components/paginator-custom/paginator-custom.component';
import { SessionModalComponent } from './components/session-modal/session-modal.component';
import { TableCellFormatDirective } from './components/table/table-cell-format.directive';
import { TableFooterFormatDirective } from './components/table/table-footer-format.directive';
import { TooltipDirective } from './components/tooltip-directive/TooltipDirective';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { MaterialModule } from './modules/material.module';
import { CheckNumberPipe, SafePipe, DateCustomPipe } from './pipes/pipes';
import { ProductoIndividualService } from './services/producto-individual.service';
import { TrasladoService } from './services/traslado.service';
import { Ng2Rut } from 'ng2-rut';
import { TooltipRentDirective } from './components/tooltip-directive/tooltopDirectiveClick';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { ErrorModalComponent } from './components/error-modal/error-modal.component';
import { ButtonVerMasComponent } from './components/button-ver-mas/button-ver-mas.component';
import { ChartsModule } from 'ng2-charts';
import { ColapsibleTableComponent } from './components/colapsible-table/colapsible-table.component';
import { EmptyDataMessageComponent } from './components/empty-data-message/empty-data-message.component';
import { FirmaModalComponent } from './components/firma-modal/firma-modal.component';
import { PolizaGuard } from './guards/poliza.guard';
import { DialogMessageModalComponent } from './components/dialog-message-modal/dialog-message-modal.component';
import { TermsComponent } from './components/terms/terms.component';

import {
  DateTablePipe,
  CurrencyTablePipe,
  PercentageTablePipe,
  PurePercentageTablePipe,
  DateNombreMesTablePipe,
  EdadTablePipe,
} from './components/table/table-pipe';
import { RescatesComponent } from './components/rescates/rescates.component';
import { AnulaPolizaComponent } from './components/anula-poliza/anula-poliza.component';
// tslint:disable-next-line: max-line-length
import { DialogFormularioPrimaEnExcesoComponent } from './components/dialog-formulario-prima-en-exceso/dialog-formulario-prima-en-exceso.component';
import { ElementsModule } from './elements/elements.module';
import { DomService } from './services/dom.service';
import { LoadingService } from './services/loading.service';
import { LoadingMultipleRequestComponent } from './components/loading-multiple-request/loading-multiple-request.component';
// tslint:disable-next-line: max-line-length
import { DialogFormularioEndosoBeneficiariosComponent } from './components/dialog-formulario-endoso-beneficiarios/dialog-formulario-endoso-beneficiarios.component';
import { FormInputFileComponent } from './components/form-input-file/form-input-file.component';
import { DialogStatusMessageComponent } from './components/dialog-status-message/dialog-status-message.component';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { FormInputRutComponent } from './components/form-input-rut/form-input-rut.component';
import { DsInputComponent } from './astro/ds-input/ds-input.component';
import '@vs-design-system/ds-input';
import { DsDatepickerComponent } from './astro/ds-datepicker/ds-datepicker/ds-datepicker.component';
import '@vs-design-system/ds-datepicker';
import { DsSelectComponent } from './astro/ds-select/ds-select/ds-select.component';
import '@vs-design-system/ds-select';
import { DsButtonComponent } from './astro/ds-button/ds-button/ds-button.component';
import '@vs-design-system/ds-tooltip';
import { EmptyWarningMessageComponent } from './components/empty-warning-message/empty-warning-message.component';

registerLocaleData(localeCL, 'es-CL');
@NgModule({
  declarations: [
    InputTextComponent,
    LoadingComponent,
    ButtonComponent,
    TableComponent,
    FormLablelComponent,
    FormTextComponent,
    FormTitleLabelComponent,
    CardDatosContratanteProductoComponent,
    CustomModalComponent,
    TableCellFormatDirective,
    TableFooterFormatDirective,
    CheckNumberPipe,
    SafePipe,
    MiniLoaderComponent,
    PrintButtonComponent,
    CardAseguradoComponent,
    SessionModalComponent,
    WebPayComponent,
    ErrorComponent,
    JsonViewComponent,
    CardComponentComponent,
    ColapsableComponent,
    FormInputTextComponent,
    FormSelectComponent,
    FormInputDateComponent,
    PaginatorCustomComponent,
    TooltipComponent,
    TooltipDirective,
    FormSelectHeaderComponent,
    AportesInputComponent,
    AportesInputCUIComponent,
    DynamicBannerComponent,
    ErrorBannerComponent,
    FormDateDesdeHastaComponent,
    PagarProductosComponent,
    CardPagarProductoComponent,
    TooltipRentDirective,
    ErrorModalComponent,
    FirmaModalComponent,
    ButtonVerMasComponent,
    ColapsibleTableComponent,
    EmptyDataMessageComponent,
    DialogMessageModalComponent,
    DateTablePipe,
    CurrencyTablePipe,
    PercentageTablePipe,
    PurePercentageTablePipe,
    DateNombreMesTablePipe,
    EdadTablePipe,
    RescatesComponent,
    AnulaPolizaComponent,
    DialogFormularioPrimaEnExcesoComponent,
    DialogFormularioEndosoBeneficiariosComponent,
    DateCustomPipe,
    LoadingMultipleRequestComponent,
    FormInputFileComponent,
    DialogStatusMessageComponent,
    ConfirmationModalComponent,
    FormInputRutComponent,
    DsInputComponent,
    DsDatepickerComponent,
    DsSelectComponent,
    DsButtonComponent,
    EmptyWarningMessageComponent,
    TermsComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    AngularSvgIconModule,
    RouterModule,
    MatDatepickerModule,
    FormsModule,
    PdfViewerModule,
    NgxMaskModule.forRoot(),
    NgxDaterangepickerMd.forRoot(),
    NgScrollbarModule,
    Ng2Rut,
    ChartsModule,
    ElementsModule,
  ],
  entryComponents: [
    SessionModalComponent,
    ErrorModalComponent,
    FirmaModalComponent,
    TooltipComponent,
    DialogMessageModalComponent,
    DialogFormularioPrimaEnExcesoComponent,
    DialogFormularioEndosoBeneficiariosComponent,
    DialogStatusMessageComponent,
    LoadingMultipleRequestComponent,
    FormInputFileComponent,
    ConfirmationModalComponent,
  ],
  exports: [
    InputTextComponent,
    ButtonComponent,
    LoadingComponent,
    TableComponent,
    ReactiveFormsModule,
    MaterialModule,
    FormLablelComponent,
    FormTextComponent,
    FormTitleLabelComponent,
    CardDatosContratanteProductoComponent,
    MiniLoaderComponent,
    CheckNumberPipe,
    SafePipe,
    DateCustomPipe,
    PrintButtonComponent,
    AngularSvgIconModule,
    CardAseguradoComponent,
    FormsModule,
    ErrorComponent,
    PdfViewerModule,
    FormsModule,
    JsonViewComponent,
    WebPayComponent,
    ColapsableComponent,
    CardComponentComponent,
    FormInputTextComponent,
    FormSelectComponent,
    FormInputDateComponent,
    PaginatorCustomComponent,
    TooltipComponent,
    TooltipDirective,
    TooltipRentDirective,
    FormSelectHeaderComponent,
    AportesInputComponent,
    AportesInputCUIComponent,
    DynamicBannerComponent,
    ErrorBannerComponent,
    FormDateDesdeHastaComponent,
    PagarProductosComponent,
    CardPagarProductoComponent,
    Ng2Rut,
    ElementsModule,
    ButtonVerMasComponent,
    ColapsibleTableComponent,
    ChartsModule,
    EmptyDataMessageComponent,
    FirmaModalComponent,
    RescatesComponent,
    FormInputFileComponent,
    FormInputRutComponent,
    DsInputComponent,
    DsDatepickerComponent,
    DsSelectComponent,
    DsButtonComponent,
    EmptyWarningMessageComponent,
    TermsComponent,
  ],
  providers: [
    LoaderService,
    ProductService,
    PersonService,
    UbicationService,
    AuthGuard,
    CommonService,
    ProductoIndividualService,
    TrasladoService,
    DomService,
    LoadingService,
    WebPayService,
    {
      provide: LOCALE_ID,
      useValue: 'es-CL',
    },
    PolizaGuard,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
